/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIRequest } from './APIRequest';
import {
    APIRequestFromJSON,
    APIRequestFromJSONTyped,
    APIRequestToJSON,
} from './APIRequest';

/**
 * 
 * @export
 * @interface APIPaginatedRequestList
 */
export interface APIPaginatedRequestList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedRequestList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedRequestList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedRequestList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIRequest>}
     * @memberof APIPaginatedRequestList
     */
    results: Array<APIRequest>;
}

/**
 * Check if a given object implements the APIPaginatedRequestList interface.
 */
export function instanceOfAPIPaginatedRequestList(value: object): value is APIPaginatedRequestList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedRequestListFromJSON(json: any): APIPaginatedRequestList {
    return APIPaginatedRequestListFromJSONTyped(json, false);
}

export function APIPaginatedRequestListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedRequestList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIRequestFromJSON)),
    };
}

export function APIPaginatedRequestListToJSON(value?: APIPaginatedRequestList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIRequestToJSON)),
    };
}

